import React, { Component } from "react"
import { connect } from "react-redux"
import { DckSelectors, DckActionCreators } from "dck-redux"

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table"
import * as ItemTypes from "../../redux/items/types"
import { Col, Row} from "react-bootstrap"
import AddAgeSettingForm from "./AddAgeSettingForm"
import CountryCodes from "./CountryCodes"
import processTypes from "../../redux/processes/types"
import FontAwesome from "react-fontawesome"
import AgeModalForm from "./AgeModalForm"
import ProcessesStatus from "../fragments/ProcessesStatus"
import { sortNumber } from "../../lib/utils"

class ListAges extends Component {

  constructor(props) {

    super(props)
    this.state = {
      showUpdateModal: false,
      countryCode: '',
      min: '',
      max: '',
    }

    this.customConfirm = this.customConfirm.bind(this)
  }

  componentDidMount() {
    this.props.loadAgeSettings()
  }

  /**
   * Getting the Country's name using the alpha-2 code
   */
  getCountryNameByCode = code => code === 'default' ? 'Default' : CountryCodes[code]

  /**
   * Delete all checked items
   */
  customConfirm(next, dropRowKeys) {

    const countryNames = dropRowKeys.map(item => this.getCountryNameByCode(item))

    if (window.confirm(`Are you sure you want to delete ${countryNames.join(', ')}?`)) {

      const { deleteAgeSetting, loadAgeSettings } = this.props
      for(let code in dropRowKeys) {
        deleteAgeSetting(dropRowKeys[code])
      }

      setTimeout(loadAgeSettings, 800)
      next()
    }
  }

  updateSingleItem = (countryCode, min, max) => this.setState({
    countryCode,
    min,
    max,
    showUpdateModal: true,
  })

  /**
   * Deleting a single item
   */
  deleteSingleItem = countryCode => {

    const countryName = this.getCountryNameByCode(countryCode)
    if (window.confirm(`Are you sure you want to delete ${countryName}?`)) {
      const { deleteAgeSetting, loadAgeSettings } = this.props
      deleteAgeSetting(countryCode)
      setTimeout(loadAgeSettings, 800)
    }
  }

  handleClose = () => {
    this.props.loadAgeSettings()
    this.setState({ showUpdateModal: false })
  }

  render() {

    const { isProcessFailed, processResult, isProcessRunning, isProcessSuccessful,
      loadAgeSettings, ageSettings, isProcessUpdateRunning, isProcessUpdateSuccessful,
      isProcessUpdateFailed, processUpdateResult, updateAgeSetting } = this.props,

    { showUpdateModal, countryCode, max, min } = this.state

    return (
      <Row className="mt-20">

        <Col md={8}>

          <ProcessesStatus
            error={ isProcessFailed ? processResult.result.text : null }
            running={ isProcessRunning }
            success={ isProcessSuccessful }
          />

          <AddAgeSettingForm loadAgeSettings={ loadAgeSettings } />

          <BootstrapTable
            data={ ageSettings } 
            hover={ true }
            condensed 
            pagination
            striped
            deleteRow
            selectRow={{  mode: 'checkbox' }}
            options={{
              handleConfirmDeleteRow: this.customConfirm,
              insertModalHeader: this.renderHeaderModal,
              onDeleteRow: this.deleteRowCallback,
            }}>

            <TableHeaderColumn
              dataField="countryCode"
              dataSort={true}
              isKey={true}
              filter={{ type: "TextFilter", delay: 1000 }}
              dataFormat={cell => this.getCountryNameByCode(cell)}
            >
              Country
            </TableHeaderColumn>

            <TableHeaderColumn
              dataField="min"
              dataAlign="center"
              dataSort
              sortFunc={(a, b, order) => sortNumber(a.min, b.min, order)}
              filter={{ type: "TextFilter", delay: 1000 }}
            >
              Min
            </TableHeaderColumn>

            <TableHeaderColumn
              dataField="max"
              dataAlign="center"
              dataSort
              sortFunc={(a, b, order) => sortNumber(a.max, b.max, order)}
              filter={{ type: "TextFilter", delay: 1000 }}
            >
              Max
            </TableHeaderColumn>

            <TableHeaderColumn
              dataField="id"
              dataAlign="center"
              width="80px"
              tdStyle={{verticalAlign: 'middle'}}
              dataFormat={(_, row) => (
                <span>
                  <span onClick={() => this.updateSingleItem(row.countryCode, row.min, row.max) }>
                    <FontAwesome name="pencil" className="blue cursor-pointer" title='Update' />
                  </span>

                  { row.countryCode !== 'default' && 
                    <span>
                      &nbsp; &nbsp; &nbsp;
                      <span onClick={() => this.deleteSingleItem(row.countryCode) }>
                        <FontAwesome name="trash-o" className="red cursor-pointer" title='Delete' />
                      </span>
                    </span>
                  }
                </span>
              )}
            />
          </BootstrapTable>

          <AgeModalForm
            show={ showUpdateModal }
            handleClose={ this.handleClose }
            saveAgeSetting={data => updateAgeSetting(countryCode, data)}

            isUpdate={ true }
            title='Update Age Setting'
            buttonText='Update'

            countryCode={ countryCode }
            setCountryCode={countryCode => this.setState({countryCode}) }

            min={ min }
            setMin={min => this.setState({min}) }

            max={ max }
            setMax={max => this.setState({max}) }

            running={ isProcessUpdateRunning }
            success={ isProcessUpdateSuccessful }
            error={ isProcessUpdateFailed ? processUpdateResult.result.text : null }
          />
        </Col>

        <Col md={4}>
          <h3>Tips</h3>
          <ul>
            <li>Use the <strong>"+New"</strong> button to add an age setting for a country.</li>
            <li>The country with the <strong>"Default"</strong> name will apply to all countries where the age setting is not defined.</li>
            <li>To delete, please use the checkbox and click the <strong>"Delete"</strong> button.</li> 
          </ul>
        </Col>
      </Row>
    )
  }
}

const mapStateToProps = state => {

  const mapping = {

    ageSettings: DckSelectors.selectAllItems(state, ItemTypes.AgeSetting),

    // Updating
    isProcessUpdateRunning: DckSelectors.selectProcessRunning(
      state,
      processTypes.UPDATE_AGE_SETTING
    ),
    isProcessUpdateFailed: DckSelectors.selectProcessFailed(
      state,
      processTypes.UPDATE_AGE_SETTING
    ),
    isProcessUpdateSuccessful: DckSelectors.selectProcessSuccess(
      state,
      processTypes.UPDATE_AGE_SETTING
    ),
    processUpdateResult: DckSelectors.selectProcess(
      state,
      processTypes.UPDATE_AGE_SETTING
    ),

    // Deleting
    isProcessRunning: DckSelectors.selectProcessRunning(
      state,
      processTypes.DELETE_AGE_SETTING
    ),
    isProcessFailed: DckSelectors.selectProcessFailed(
      state,
      processTypes.DELETE_AGE_SETTING
    ),
    isProcessSuccessful: DckSelectors.selectProcessSuccess(
      state,
      processTypes.DELETE_AGE_SETTING
    ),
    processResult: DckSelectors.selectProcess(
      state, 
      processTypes.DELETE_AGE_SETTING
    ),
  }

  return mapping
},

mapDispatchToProps = dispatch => ({
  loadAgeSettings: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.AgeSetting)),
  updateAgeSetting: (id, data) => dispatch(DckActionCreators.itemSave(ItemTypes.AgeSetting, id, data)),
  deleteAgeSetting: id => dispatch(DckActionCreators.itemRemove(ItemTypes.AgeSetting, id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListAges)



// WEBPACK FOOTER //
// ./src/components/Settings/ListAge.js